export default {
	openMarkupDialog(state, payload) {
        state.markupDialogOpen = payload;
    },

    updateHasActiveCostSplit(state, payload) {
    	state.has_active_cost_split = payload;
    },

    createMarkupForm(state, payload) {
        Object.assign(state.markupForm, payload.cost_split);
        state.markupForm.media_id = payload.media.media_id;
        state.markupForm.keep_image = payload.keep_image;
    	state.markupForm.share_reset.member_share_reset = payload.cost_split.member_share;
        state.markupForm.share_reset.comarketer_share_reset = payload.cost_split.comarketer_share;
        state.markupForm.hideEdit = (state.markupForm.markup_image) ? true : false;
        state.markupForm.current_image = state.markupForm.hideEdit;
        if(state.markupForm.id != '') {
            state.has_active_cost_split = true;
        }
    },

	updateMarkupData(state, payload) {
		Object.assign(state.markupForm, payload);
    },

    passMouseMoveEvent(state, payload) {
    	// passes mouse move event from container to editor
    },

    passMouseUpEvent(state, payload) {
    	// passes mouse up event from container to editor
    },

    resetMarkupForm(state) {
    	// passes reset event from form_panel/dialog to editor
    	state.markupForm.member_share = state.markupForm.share_reset.member_share_reset;
        state.markupForm.comarketer_share = state.markupForm.share_reset.comarketer_share_reset;
    },

    passCalculateSharesEvent(state) {
    	// passes calculate event from form_panel to editor
    },

    passSaveEvent(state) {
    	// passes save event from dialog to form_panel
    }
}